import { Box } from "@components/Layout"
import { breakpoints } from "@config/theme"
import styled, { css } from "styled-components"
import { gridColumn, GridColumnProps } from "styled-system"
import * as S from "../elements"

export const Content = styled(Box)`
  ${S.BasicContentStyle};
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  color: white;
  position: absolute;

  svg {
    height: 1rem;
    width: 1rem;
    margin-left: 0.5rem;
    fill: white;
    transition: transform 0.25s ease-in-out;
  }
`

export const Background = styled.img<{ loading: string }>`
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  z-index: 0;
  top: 0;
  left: 0;
  object-fit: cover;
  object-position: top center;
  transform: scale(1.03, 1.03);
  transition: transform 0.2s ease-in-out;
`
interface AnchorProps extends GridColumnProps {
  ratio?: string[]
}

export const Anchor = styled.a<AnchorProps>`
  ${gridColumn};
  cursor: pointer;
  mask-image: radial-gradient(white, black);
  position: relative;
  page-break-inside: avoid;
  background-color: ${(p) => p.theme.colors.softGrey};
  overflow: hidden;
  display: block;
  position: relative;

  @media screen and (min-width: ${breakpoints.small}) {
    margin-bottom: 0.75rem;
  }
  @media screen and (min-width: ${breakpoints.medium}) {
    margin-bottom: 1.5rem;
  }
  ${(p) =>
    p.ratio
      ? css`
          position: relative;
          &::before {
            padding-top: ${p.ratio[0]};
            content: "";
            display: block;
            @media screen and (min-width: ${breakpoints.small}) {
              padding-top: ${p.ratio[1]};
            }
            @media screen and (min-width: ${breakpoints.medium}) {
              padding-top: ${p.ratio[2]};
            }
          }
        `
      : css`
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        `};

  &:hover,
  &:focus {
    outline: 0;
    backface-visibility: hidden;
    overflow: hidden;

    svg {
      transform: translateX(0.25rem);
    }
    ${Background} {
      transform: scale(1.01, 1.01);
    }
  }

  &::after {
    position: absolute;
    width: 100%;
    height: 40%;
    content: "";
    bottom: 0;
    transition: all 0.1s cubic-bezier(0.23, 1, 0.32, 1);
    /* background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.35) 100%); */
    background-size: 100% 20%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
    opacity: 0.26;
    background-repeat: no-repeat;
    background-position: bottom;
  }
`
